import { ToolbarActionTypes, ToolbarClickAction } from 'redux/toolbar/toolbarActions';

export const isToolbarClick = (action: any): action is ToolbarClickAction =>
  action?.type === ToolbarActionTypes.CLICK;
